import * as React from 'react';
import { Box, BoxProps, Stack, TextFieldProps, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Control, Controller } from 'react-hook-form';

export type FormDateTimeFieldProps = TextFieldProps  & {
  control: Control<any>;
  name: string;
  defaultValue?: string;
  labelComponent?: React.ReactElement;
  label: string;
  size?: 'small' | 'medium';
  description?: string;
  containerProps?: BoxProps;
  onChangeInput?: (value: any) => void;
  minDateTime?: Date;
  maxDateTime?: Date;
};

/**
 * Describe your component here
 */
const FormDateTimeField: React.FC<FormDateTimeFieldProps> = (props) => {
  const {
    name,
    control,
    label,
    labelComponent,
    description,
    containerProps,
    onChangeInput,
    size = 'small',
    defaultValue = '',
    minDateTime,
    maxDateTime,
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={containerProps?.sx}>
        {labelComponent}
        {
        description && (
          <Typography variant='body2' sx={{
            color: '#827a7a'
          }} mb={1} >{description}</Typography>
        )
        }
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange, value } }) => (
            <Stack sx={{ width: '100%' }}>
              <DateTimePicker
                slotProps={{ textField: { label, size } }}
                value={value}
                maxDateTime={maxDateTime}
                minDateTime={minDateTime}
                onChange={(e) => {
                  onChange(e);
                  if (onChangeInput) onChangeInput(e);
                }}
                onAccept={onChange}
              />
            </Stack>
          )}
          defaultValue={defaultValue}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default FormDateTimeField;
